import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

const ModalConfirmacaoChaves = ({ show, chaves, onConfirmar, onCancelar }) => (
  <Modal show={show} onHide={onCancelar} centered backdrop="static">
    <Modal.Header closeButton>
      <Modal.Title>Atenção — Chaves não pagas</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        Existe(m) Ativo(s) vinculado(s) com chave(s) não paga(s). Confirma o lançamento?
      </p>
      {chaves && chaves.length > 0 && (
        <Table striped bordered size="sm">
          <thead className="thead-light">
            <tr>
              <th>Quadra</th>
              <th>Lote</th>
            </tr>
          </thead>
          <tbody>
            {chaves.map((c) => (
              <tr key={`chave-${c.codigo_ativo}`}>
                <td>{c.quadra}</td>
                <td>{c.lote}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onCancelar}>
        Não
      </Button>
      <Button variant="warning" onClick={onConfirmar}>
        Sim, Lançar
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalConfirmacaoChaves;
